"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TSCertificate = void 0;
class TSCertificate extends Phaser.GameObjects.Container {
    constructor(scene, x, y, topText, bottomText) {
        super(scene, x, y);
        this.add(scene.add.sprite(0, 0, 'certificate').setOrigin(0));
        this.add(scene.add.bitmapText(32, 21, 'font', topText, 6).setOrigin(0.5).setTint(0x0));
        // this.add.bitmapText(32, 32, 'font', "YOU ARE A", 6).setOrigin(0.5).setTint(0xFFFFFF);
        this.add(scene.add.bitmapText(32, 43, 'font', bottomText[0].toUpperCase(), 6).setOrigin(0.5).setTint(bottomText[1]));
    }
}
exports.TSCertificate = TSCertificate;
